export const environment = {
  appTitle: "QEmpower",
  appVersion: "1.5.1",
  name: 'staging',
  production: false,
  applicationUrl: "https://staging-qundis.digital-worx.de",
  supabaseUrl: "https://dzycnolgqwswdhlsdryi.supabase.co",
  supabaseProjectId: "dzycnolgqwswdhlsdryi",
  supabaseKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6eWNub2xncXdzd2RobHNkcnlpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzIyMDE4ODAsImV4cCI6MjA0Nzc3Nzg4MH0.f5xwC76mceqB94gse18Rq9eCUEX14SyKU34i6lHNzH4",
  supabaseEdgeFunctionEndpoint: 'https://dzycnolgqwswdhlsdryi.supabase.co/functions/v1',
  authEmail: "@no-reply.qundis-tool.com",
  editorAiPluginLabel: "QundisGPT",
  editorAiPluginEndpoint: "https://qundisgpt-apa4b3ehhtdrdbcf.germanywestcentral-01.azurewebsites.net/Chat",
  deletedSystemUserUuid: "cceff2d6-45ba-464f-941c-0a28c36db4f5"
};
